import React from "react";

import { ListStyled } from "../../theme";

import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";

export const RepairTypeDetail = ({
  repair,
  isActive,
  Edit,
  Delete,
  Select,
  Add,
  Remove,
  selectedModel,
  repairTypeId,
}) => {
  const editHandler = () => Edit && Edit(repair);
  const deleteHandler = () => Delete && Delete(repair.id);
  const selectHandler = () => Select && Select(repair);
  const addHandler = () => Add && !isActive && Add(repair);
  const removeHandler = () =>
    Remove && Remove(repairTypeId ? repairTypeId : repair.id);
  return (
    <ListStyled isActive={isActive}>
      <div className="detail" onClick={selectHandler}>
        {repair.name}
        <span>{repair.description}</span>
      </div>
      {Remove && (
        <span className="remove" onClick={removeHandler}>
          <RemoveOutlinedIcon />
        </span>
      )}

      {Add && !isActive && selectedModel && (
        <span className="add" onClick={addHandler}>
          <AddOutlinedIcon />
        </span>
      )}
      {Edit && (
        <span className="edit" onClick={editHandler}>
          <EditOutlinedIcon />
        </span>
      )}
      {Delete && (
        <span className="delete" onClick={deleteHandler}>
          <DeleteOutlineOutlinedIcon />
        </span>
      )}
    </ListStyled>
  );
};
